export const environment = {
    production: true,
    apiEndpoint: location.protocol + '//' + location.hostname,
    replicaEndpoint: 'server1.de-rena.de'
};
